import { createGlobalStyle } from 'styled-components';

import theme from '@/theme';
import { THEME } from '@enmon/commons';
import { getTreeSelectCheckboxStyles } from './components/form/TreeSelect/utils/getTreeSelectCheckboxStyles';

const GlobalStyle = createGlobalStyle`
  html,
  body {
    height: 100%;
    width: 100%;
    font-size: 16px;
    overflow-y: hidden;
    font-family: ${theme.fonts.body.family};
    overflow-x: hidden;
  }

  // selection color
  ::selection {
    background-color: ${THEME.color.semantic.primary.background.hover};
    color: ${THEME.color.core.white};
  }
  ::-webkit-selection {
    background-color: ${THEME.color.semantic.primary.background.hover};
    color: ${THEME.color.core.white};
  }
  ::-moz-selection {
    background-color: ${THEME.color.semantic.primary.background.hover};
    color: ${THEME.color.core.white};
  }

  // NOTE: Media query for PDF reports on Carbon Footprint Overview page using react-to-print library
  //       See: https://github.com/gregnb/react-to-print/issues/54
  @media print { html, body { height: initial !important; overflow: initial !important; }}

  #app {
    min-height: 100%;
    height: 100%;
    min-width: 100%;
    overflow: hidden;
  }

  a:hover {
    text-decoration: none;
  }

  ::placeholder,
  .ant-select-placeholder {
    font-style: italic;
    width: 100%;
  }

  sup {
    font-size: 60%;
  }

   b, strong {
    font-weight: 500;
  }

  .Toastify {
    .Toastify__toast {
      max-width: 24rem;
      border-radius: 2px;
      padding: 1rem;
      margin-bottom: 0;
      margin-top: 0.4rem;
      &.Toastify__toast--default {
        color: ${theme.colors.neutralPrimaryAlt};

        .Toastify__close-button {
          color: ${theme.colors.neutralPrimaryAlt};
        }

        .Toastify__progress-bar {
          background: ${theme.colors.themePrimary};
        }
      }
      &.Toastify__toast--error {
        background: ${theme.colors.white};
        color: ${theme.colors.themeError};

        .Toastify__close-button {
          color: ${theme.colors.themeError};
        }

        .Toastify__progress-bar {
          background: ${theme.colors.themeError};
        }
      }
    }


  }

  .ant-page-header-heading-title {
    font-weight: 500;
  }

  .col-xxl-10 {
    @media(min-width: 1600px) {
      flex: 0 0 83.33333333%;
      max-width: 83.33333333%;
    }
  }

  .col-xxl-9 {
    @media(min-width: 1600px) {
      flex: 0 0 75%;
      max-width: 75%;
    }
  }

  .col-xxl-6 {
    @media(min-width: 1600px) {
      flex: 0 0 50%;
      max-width: 50%;
    }
  }

  .col-xxl-3 {
    @media(min-width: 1600px) {
      flex: 0 0 25%;
      max-width: 25%;
    }
  }

  .col-xxl-2 {
    @media(min-width: 1600px) {
      flex: 0 0 16.666666666%;
      max-width: 16.666666666%;
    }
  }

  .mb-xxl-0 {
    @media(min-width: 1600px) {
      margin-bottom: 0 !important;
    }
  }

  .row {
    margin-left: -0.5rem;
    margin-right: -0.5rem;
  }

  .col-1, .col-2, .col-3, .col-4, .col-5, .col-6, .col-7,
  .col-8, .col-9, .col-10, .col-11, .col-12, .col, .col-auto,
  .col-sm-1, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5,
  .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-10,
  .col-sm-11, .col-sm-12, .col-sm, .col-sm-auto,
  .col-md-1, .col-md-2, .col-md-3, .col-md-4, .col-md-5,
  .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-10,
  .col-md-11, .col-md-12, .col-md, .col-md-auto,
  .col-lg-1, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5,
  .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-10,
  .col-lg-11, .col-lg-12, .col-lg, .col-lg-auto,
  .col-xl-1, .col-xl-2, .col-xl-3, .col-xl-4, .col-xl-5,
  .col-xl-6, .col-xl-7, .col-xl-8, .col-xl-9, .col-xl-10,
  .col-xl-11, .col-xl-12, .col-xl, .col-xl-auto,
  .col-xxl-1, .col-xxl-2, .col-xxl-3, .col-xxl-4, .col-xxl-5,
   .col-xxl-6, .col-xxl-7, .col-xxl-8, .col-xxl-9, .col-xxl-10,
   .col-xxl-11, .col-xxl-12, .col-xxl, .col-xxl-auto {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .hidden-xxl {
    display: initial;
    @media(min-width: 1600px) {
      display: none;
    }
  }

  .visible-xxl {
    display: none;
    @media(min-width: 1600px) {
      display: initial;
    }
  }

  .ant-select-tree-show-line .ant-select-tree-switcher-line-icon {
    vertical-align: -1px;
  }

  .ant-select-tree-checkbox {
    margin: 6px 4px 0 4px;
  }

  .ant-select-dropdown {
    ${getTreeSelectCheckboxStyles}
  }

  .ant-tooltip {
    max-width: 800px;
  }

  .ant-popover {
    .ant-popover-inner {
      padding: 12px 16px;

      .ant-popconfirm-message {
        margin-bottom: 12px;

        .ant-popconfirm-message-icon {
          margin-right: 8px;
        }
      }
    }
  }

  // NOTE: TimePicker from antd is not using configured primary theme color for Now button
  .ant-picker-now-btn {
    color: ${theme.color.theme.primary};
  }
  .ant-picker-now-btn:hover {
    color: ${theme.color.theme.primary};
  }

  // Form components: full-width by default so each wrapper doesn't need inline style
  .ant-input,
  .ant-input-number,
  .ant-select,
  .ant-tree-select,
  .ant-picker {
    width: 100%;
  }

  // Form components: prefix/suffix/arrow icons use primary color
  // Excludes status states so their colors take precedence
  .ant-input-affix-wrapper:not(.ant-input-status-error):not(.ant-input-status-warning):not(.ant-input-status-success):not(.ant-input-status-validating) {
    .ant-input-prefix,
    .ant-input-suffix {
      .anticon,
      svg {
        color: ${theme.color.theme.primary};
      }
    }
  }

  .ant-input-number-affix-wrapper:not(.ant-input-number-status-error):not(.ant-input-number-status-warning):not(.ant-input-number-status-success):not(.ant-input-number-status-validating) {
    .ant-input-number-prefix,
    .ant-input-number-suffix {
      .anticon,
      svg {
        color: ${theme.color.theme.primary};
      }
    }
  }

  .ant-select:not(.ant-select-status-error):not(.ant-select-status-warning):not(.ant-select-status-success):not(.ant-select-status-validating) {
    .ant-select-arrow,
    .ant-select-suffix,
    .ant-select-prefix {
      .anticon,
      svg {
        color: ${theme.color.theme.primary};
      }
    }
  }

  .ant-picker:not(.ant-picker-status-error):not(.ant-picker-status-warning):not(.ant-picker-status-success):not(.ant-picker-status-validating) {
    .ant-picker-suffix {
      .anticon,
      svg {
        color: ${theme.color.theme.primary};
      }
    }
  }

  // Form component disabled state per Figma design:
  // - no border on disabled inputs
  // - value text stays readable (primary) instead of fading to disabled color
  .ant-input-disabled,
  .ant-input-number-disabled,
  .ant-picker-disabled {
    border-color: transparent !important;
  }

  .ant-input-disabled input,
  .ant-input-disabled textarea,
  .ant-input-number-disabled input,
  .ant-picker-disabled input {
    color: ${THEME.color.semantic.type.primary};
  }

  // antd forces label height to control height on large forms, breaking custom label spacing
  .ant-form-large .ant-form-item .ant-form-item-label > label {
    height: auto;
  }
  .ant-form-small .ant-form-item .ant-form-item-label > label {
    height: auto;
  }


  // global styles for date range picker popover
  .date-range-picker-popover {
    .ant-popover-inner {
      padding: unset !important;
    }
  }

  // NOTE: Global styles for antd tooltips
  .ant-tooltip {
    &&& .ant-tooltip-content {
      padding: unset;
      box-shadow: 0px 6.4px 14.4px 0px #00000021, 0px 1.2px 3.6px 0px #0000001a;
      max-width: 800px;
      border-radius: 8px;
    }

    &&& .ant-tooltip-inner {
      padding: 16px;
      max-width: 800px;
      font-size: ${theme.font.size.xs}px;
      border-radius: 8px;
      a {
        font-size: ${theme.font.size.sm}px;
        color: ${theme.color.theme.primary};
        &:hover {
          color: ${theme.color.theme.primary};
        }
      }
    }
  }

  // NOTE: Global styles for antd dropdowns overlays
  .ant-dropdown,
  .ant-tabs-dropdown {
    .ant-dropdown-menu,
    .ant-tabs-dropdown-menu {
      font-family: ${theme.font.typography.bodyText.fontFamily};
      border-radius: 2px;

      .ant-dropdown-menu-item,
      .ant-tabs-dropdown-menu-item {
        border-radius: 2px;
      }
    }
  }

  // NOTE: Global styles for antd day of year picker
  .day-of-year-picker .ant-picker-footer,
  .day-of-year-picker .ant-picker-header > button.ant-picker-header-super-prev-btn,
  .day-of-year-picker .ant-picker-header > button.ant-picker-header-super-next-btn,
  .day-of-year-picker .ant-picker-header button.ant-picker-year-btn {
    display: none !important;
  }

  .ant-header-image-mask {
    border-radius: 999px;
  }

  .ant-tour {
    padding: 24px;

    .ant-tour-panel {
    .ant-tour-section {
      width: min-content !important;
      min-width: 320px !important;

      & .ant-tour-header {
        padding-bottom: 16px !important;
      }

      & .ant-tour-cover {
        padding: 0 !important;
        max-height: 240px;

        & img, .ant-image-placeholder {
          border-radius: 8px 8px 0 0 !important;
          width: 480px;
        }

         .ant-image-placeholder {
          border-radius: 8px 8px 0 0 !important;
         }
      }

      & .ant-tour-footer {
        display: flex;
        padding-top: 24px !important;

        & .ant-tour-actions {
          display: flex;
          width: 100%;
          justify-content: space-between;

          & .ant-btn {
            background-color: transparent;
            box-shadow: none;
            padding: 0 30px;
            border: 1px solid ${theme.color.grey.white};
            border-radius: 4px;
            font-size: 14px;
            height: 32px;
          }

          .ant-btn:only-child {
            margin-inline-start: auto !important;
          }

          & .ant-tour-prev-btn {
            padding: 4px;
            color: ${theme.color.grey.white};
            border: none;

            &:hover {
              background-color: transparent;
              color: ${theme.color.grey.white};
              text-decoration: underline;
            }
          }
        }

        & .ant-tour-indicators {
          display: flex !important;
          justify-content: center;
          align-items: center;
        }
      }
    }
    }
  }`;

export default GlobalStyle;
